"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_10tckaifb0 = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/DrawerMenu.js";
  var hash = "c912b2a803431f6cab9afebf572e1702405f5c4c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/application-bar/DrawerMenu.js",
    statementMap: {
      "0": {
        start: {
          line: 26,
          column: 38
        },
        end: {
          line: 26,
          column: 53
        }
      },
      "1": {
        start: {
          line: 28,
          column: 23
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "2": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 31
        }
      },
      "3": {
        start: {
          line: 32,
          column: 19
        },
        end: {
          line: 40,
          column: 3
        }
      },
      "4": {
        start: {
          line: 42,
          column: 24
        },
        end: {
          line: 42,
          column: 54
        }
      },
      "5": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 66,
          column: 4
        }
      },
      "6": {
        start: {
          line: 69,
          column: 0
        },
        end: {
          line: 72,
          column: 2
        }
      },
      "7": {
        start: {
          line: 74,
          column: 17
        },
        end: {
          line: 80,
          column: 1
        }
      },
      "8": {
        start: {
          line: 75,
          column: 15
        },
        end: {
          line: 75,
          column: 47
        }
      },
      "9": {
        start: {
          line: 76,
          column: 17
        },
        end: {
          line: 76,
          column: 101
        }
      },
      "10": {
        start: {
          line: 76,
          column: 34
        },
        end: {
          line: 76,
          column: 99
        }
      },
      "11": {
        start: {
          line: 77,
          column: 16
        },
        end: {
          line: 77,
          column: 39
        }
      },
      "12": {
        start: {
          line: 79,
          column: 2
        },
        end: {
          line: 79,
          column: 15
        }
      },
      "13": {
        start: {
          line: 82,
          column: 26
        },
        end: {
          line: 82,
          column: 87
        }
      }
    },
    fnMap: {
      "0": {
        name: "DrawerMenuComponent",
        decl: {
          start: {
            line: 18,
            column: 9
          },
          end: {
            line: 18,
            column: 28
          }
        },
        loc: {
          start: {
            line: 25,
            column: 3
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 25
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 23
          },
          end: {
            line: 28,
            column: 24
          }
        },
        loc: {
          start: {
            line: 28,
            column: 29
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 74,
            column: 17
          },
          end: {
            line: 74,
            column: 18
          }
        },
        loc: {
          start: {
            line: 74,
            column: 43
          },
          end: {
            line: 80,
            column: 1
          }
        },
        line: 74
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 76,
            column: 26
          },
          end: {
            line: 76,
            column: 27
          }
        },
        loc: {
          start: {
            line: 76,
            column: 34
          },
          end: {
            line: 76,
            column: 99
          }
        },
        line: 76
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 32,
            column: 19
          },
          end: {
            line: 40,
            column: 3
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 35
          },
          end: {
            line: 32,
            column: 40
          }
        }, {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 39,
            column: 6
          }
        }],
        line: 32
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "c912b2a803431f6cab9afebf572e1702405f5c4c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawerMenu = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _ = require("../");

var _styles2 = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function DrawerMenuComponent(_ref) {
  var classes = _ref.classes,
      drawerMenu = _ref.drawerMenu,
      blob = _ref.blob,
      onBlob = _ref.onBlob,
      repository = _ref.repository,
      config = _ref.config;
  cov_10tckaifb0.f[0]++;

  var _ref2 = (cov_10tckaifb0.s[0]++, (0, _react.useState)(false)),
      _ref3 = _slicedToArray(_ref2, 2),
      openDrawer = _ref3[0],
      setOpenDrawer = _ref3[1];

  cov_10tckaifb0.s[1]++;

  var toggleDrawer = function toggleDrawer() {
    cov_10tckaifb0.f[1]++;
    cov_10tckaifb0.s[2]++;
    setOpenDrawer(!openDrawer);
  };

  var fileTree = (cov_10tckaifb0.s[3]++, !repository ? (cov_10tckaifb0.b[0][0]++, _react.default.createElement(_react.default.Fragment, null)) : (cov_10tckaifb0.b[0][1]++, _react.default.createElement(_.Tree, {
    url: repository.tree_url,
    blob: blob,
    onBlob: onBlob,
    config: config,
    selected: true
  })));
  var drawerClasses = (cov_10tckaifb0.s[4]++, {
    paper: classes.drawerPaper
  });
  cov_10tckaifb0.s[5]++;
  return _react.default.createElement("div", null, _react.default.createElement(_core.IconButton, {
    "data-test": "drawer-menu-button",
    color: "inherit",
    "aria-label": "Menu",
    onClick: toggleDrawer
  }, _react.default.createElement(_icons.Menu, null)), _react.default.createElement(_core.Drawer, {
    className: classes.drawer,
    variant: "temporary",
    anchor: "left",
    open: openDrawer,
    onClose: toggleDrawer,
    classes: drawerClasses
  }, _react.default.createElement("div", {
    className: classes.drawerHeader
  }, _react.default.createElement(_core.IconButton, {
    "data-test": "drawer-menu-close-button",
    onClick: toggleDrawer
  }, _react.default.createElement(_icons.ChevronLeft, null))), _react.default.createElement(_core.Divider, null), drawerMenu, _react.default.createElement(_core.Divider, null), fileTree, _react.default.createElement(_core.Divider, null)));
}

cov_10tckaifb0.s[6]++;
DrawerMenuComponent.propTypes = {
  /** Component to render inside of the drawer menu. */
  drawerMenu: _propTypes.default.element
};
cov_10tckaifb0.s[7]++;

var areEqual = function areEqual(prevProps, nextProps) {
  cov_10tckaifb0.f[2]++;
  var keys = (cov_10tckaifb0.s[8]++, ['blob', 'repository', 'config']);
  var checks = (cov_10tckaifb0.s[9]++, keys.map(function (key) {
    cov_10tckaifb0.f[3]++;
    cov_10tckaifb0.s[10]++;
    return JSON.stringify(prevProps[key]) === JSON.stringify(nextProps[key]);
  }));
  var equal = (cov_10tckaifb0.s[11]++, !checks.includes(false)); // console.log('DrawerMenuComponent', keys, checks, equal);

  cov_10tckaifb0.s[12]++;
  return equal;
};

var DrawerMenu = (cov_10tckaifb0.s[13]++, _react.default.memo((0, _styles.withStyles)(_styles2.default)(DrawerMenuComponent), areEqual));
exports.DrawerMenu = DrawerMenu;